import repository from '@/utils/repository';

const resource = '/move/MNG_Client008';

export default {
    getUserInfo: (data) => {
        return repository.post(`${resource}/getUserInfo`, {
            ...data
        });
    },
    getAreaInfo: (data) => {
        return repository.post(`move/postCommonAreaInfo`, {
            ...data
        });
    },
    getOfficeInfo: (data) => {
        return repository.post(`move/postCommonOfficeInfo`, {
            ...data
        });
    },
    storeUserInfo: (data) => {
        return repository.post(`${resource}/storeUserInfo`, {
            ...data
        });
    },
    getListDataDroppedItem: (data) => {
        return repository.post(`${resource}/listDataDroppedItem`, {
            ...data
        });
    },
    saveListDataDroppedItem: (data) => {
        return repository.post(`${resource}/saveListDataDroppedItem`, {
            ...data
        });
    },
    deleteRowItemAPI: (data) => {
        return repository.post(`${resource}/deleteRowItemAPI`, {
            ...data
        });
    },
    deleteListDataItem: (data) => {
        return repository.post(`${resource}/deleteListDataItem`, {
            ...data
        });
    },
    uploadFileImage: (data) => {
        return repository.post(`${resource}/uploadFileImage`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getImage: (path) => {
        // const parts = path.split(/[/\\]+/);
        let parts = path == null ? [''] : path.split(/[/\\]+/);
        let fileName = parts[parts.length - 1];
        return repository.get(`move/preview-image/6/${fileName}`, {
            responseType: 'blob'
        });
    }
};
